// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__dXxfM","title":"AfterFrontImage_title__1WlQ7"};